"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Wizard/Recipients/GateBlock.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _gateRefusal = require('./gateRefusal');

/* On a started campaign the gate refuses rows missing a value: why, and the
 * ways out (skip those rows, or set a default in Edit message). */
const GateBlock



 = ({ gate, onSkip, onSetDefault }) => {
  const missing = gate.MissingVariables[0]
  return (
    _react2.default.createElement('div', { role: "alert", className: "broadcast-banner broadcast-banner--danger broadcast-upload-dialog--missing"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 15}}
      , _react2.default.createElement('p', { className: "broadcast-upload-dialog--missing-line", __self: this, __source: {fileName: _jsxFileName, lineNumber: 16}},  _gateRefusal.gateRefusalText.call(void 0, gate) )
      ,  missing && (
        _react2.default.createElement('p', { className: "broadcast-upload-dialog--missing-line", __self: this, __source: {fileName: _jsxFileName, lineNumber: 18}}
          , _react2.default.createElement('button', { type: "button", className: "broadcast-link-button", onClick: () => onSkip(missing.Name), __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}}
            ,  `Skip the rows with no ${missing.Name}` 
          )
          ,  onSetDefault && (
            _react2.default.createElement(_react2.default.Fragment, null
              , ' ', "or", ' '
              , _react2.default.createElement('button', { type: "button", className: "broadcast-link-button", onClick: () => onSetDefault(missing.Name), __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}}, "set a default for "
                    ,  missing.Name 
              )
            )
          )
        )
      )
    )
  )
}

exports. default = GateBlock
